import type { ErrorCopy } from '@shared/errors/catalog';

import { analyticsErrors, financeErrors } from '../_shared/errors';

/**
 * This surface reads two services, so it carries both catalogues.
 *
 * The two bands resolve their own failures against this one map: the tone comes
 * from the entry rather than from the call site, so a peer outage renders
 * neutral on either band and never as a danger the operator will read as their
 * own mistake.
 */
export const errors: Readonly<Record<string, ErrorCopy>> = {
  ...financeErrors,
  ...analyticsErrors,
};
